.breadcrumbs {
  color: var(--gray-600);
}

.link {
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}
